import Create from "./Create";
import Stats from "./Stats";
import Table from "./Table";

function Locations() {
  return (
    <div>
        <Stats />
        <Table />
    </div>
  );
}

export default Locations;
